import { GalleryState } from 'editor/src/store/gallery/types';

import createUploadRankLookup from './createUploadRankLookup';
import getUploadKey from './getUploadKey';

// Pages exported as numbered files keep their order whichever upload reports first: a file joins the listed
// files of its own batch in file-name order. Anything else, or a file whose batch has none listed, goes on top.
const getUploadInsertIndex = (state: GalleryState, uploadKey: string | undefined) => {
  // Only its own batch counts, so images added between two batches stay between them.
  const batch = uploadKey !== undefined ? state.uploadBatches?.find((ids) => ids.includes(uploadKey)) : undefined;
  if (!batch) {
    return 0;
  }

  const getRank = createUploadRankLookup(batch);
  const rank = getRank(uploadKey) ?? 0;
  const nextIndex = state.images.findIndex((image) => (getRank(getUploadKey(image)) ?? -1) > rank);
  if (nextIndex !== -1) {
    return nextIndex;
  }

  return state.images.reduce(
    (index, image, imageIndex) => (getRank(getUploadKey(image)) !== undefined ? imageIndex + 1 : index),
    0,
  );
};

export default getUploadInsertIndex;
